/* mm-upsellhilfe.js — Sicherheitsnetz fuer den Section-Store-2er-Set-Upsell.
 *
 * Der App-Block wird vor dem Kauf-Formular verbunden und findet dieses deshalb
 * auf einigen Produktseiten nicht selbst. Das Sicherheitsnetz greift nur dann
 * ein, wenn der App-Block kein Formular verbunden hat. Beim echten Kaufklick
 * werden die vom Kunden aktivierten Zusatzprodukte zuerst als Shopify-Batch
 * angelegt. Erst nach dessen Erfolg laeuft der normale Theme-Kauf fuer den
 * Hauptartikel weiter. Shopify ignoriert `items[...]`, wenn dasselbe Formular
 * zugleich ein einzelnes `id`-Feld sendet; deshalb sind zwei geordnete Schritte
 * erforderlich.
 */
(function () {
  'use strict';

  if (!/^\/products\//.test(window.location.pathname)) return;

  function kaufFormular() {
    var formen = document.querySelectorAll(
      'form.shopify-product-form, form[action="/cart/add"], form[action*="/cart/add"]'
    );
    for (var i = 0; i < formen.length; i += 1) {
      if (formen[i].querySelector('button[type="submit"]:not([disabled])')) return formen[i];
    }
    return null;
  }

  function ausgewaehlteVarianten() {
    var gesehen = {};
    var varianten = [];
    document.querySelectorAll('section-store--product-addons-block').forEach(function (block) {
      if (!block.shadowRoot) return;
      block.shadowRoot.querySelectorAll('.addon-toggle-input:checked').forEach(function (input) {
        var variant = input.getAttribute('data-variant-id');
        if (!variant || gesehen[variant]) return;
        gesehen[variant] = true;
        varianten.push(variant);
      });
    });
    return varianten;
  }

  function fremdeZusatzfelderEntfernen(form) {
    form.querySelectorAll(
      '.mm-upsellhilfe-feld,.section-store--product-addons-block-hidden-input'
    ).forEach(function (input) { input.remove(); });
  }

  function zusatzartikelHinzufuegen(varianten) {
    return window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: varianten.map(function (id) { return { id: Number(id), quantity: 1 }; })
      })
    }).then(function (antwort) {
      return antwort.json().then(function (daten) {
        if (!antwort.ok || daten.status) {
          throw new Error(daten.description || daten.message || 'Upsell fehlgeschlagen');
        }
        return daten;
      });
    });
  }

  function bildKanten(block) {
    if (!block.shadowRoot || block.shadowRoot.getElementById('mm-upsell-bildkanten')) return;
    var stil = document.createElement('style');
    stil.id = 'mm-upsell-bildkanten';
    stil.textContent = [
      '.product-image-link{display:block!important;border-radius:10px!important;overflow:hidden!important}',
      '.product-image{display:block!important;border-radius:10px!important}'
    ].join('');
    block.shadowRoot.appendChild(stil);
  }

  /*
   * Der Section-Store-Block rendert den sichtbaren Schalter in einem offenen
   * Shadow-DOM. Auf der Produktseite kommt der Klick am Label an, aber der
   * versteckte Checkbox-Zustand wird von der App nicht umgeschaltet. Dadurch
   * kann auch kein Zusatzartikel an das Kauf-Formular uebergeben werden.
   *
   * Diese kleine Bruecke setzt nur den angeklickten Schalter, synchronisiert
   * die sichtbare Karte und feuert die normalen input/change-Ereignisse. Die
   * Varianten-ID bleibt komplett in der App; Preise und Produkte werden nicht
   * dupliziert oder hart codiert.
   */
  var reparierteWurzeln = typeof WeakSet === 'function' ? new WeakSet() : null;

  function schalterReparieren(block) {
    if (!block.shadowRoot) return;
    var wurzel = block.shadowRoot;

    wurzel.querySelectorAll('label.toggle').forEach(function (label) {
      var input = label.querySelector('.addon-toggle-input');
      if (!input) return;
      label.setAttribute('role', 'switch');
      label.setAttribute('tabindex', '0');
      label.setAttribute('aria-checked', input.checked ? 'true' : 'false');
    });
    /* Die App ersetzt den ganzen Host und uebernimmt dabei dessen Attribute.
       Deshalb ist ein data-Attribut kein verlaesslicher Listener-Nachweis. */
    if (reparierteWurzeln && reparierteWurzeln.has(wurzel)) return;

    function setzen(input, aktiv) {
      input.checked = aktiv;
      var karte = input.closest('.addons-box');
      var label = input.closest('label.toggle');
      if (karte) karte.classList.toggle('active', aktiv);
      if (label) label.setAttribute('aria-checked', aktiv ? 'true' : 'false');
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }

    wurzel.addEventListener('click', function (ereignis) {
      var ziel = ereignis.target;
      var label = ziel && ziel.closest ? ziel.closest('label.toggle') : null;
      if (!label || (ziel.classList && ziel.classList.contains('addon-toggle-input'))) return;
      var input = label.querySelector('.addon-toggle-input');
      if (!input || input.disabled) return;
      ereignis.preventDefault();
      ereignis.stopImmediatePropagation();
      setzen(input, !input.checked);
    }, true);

    wurzel.addEventListener('keydown', function (ereignis) {
      var label = ereignis.target && ereignis.target.closest
        ? ereignis.target.closest('label.toggle') : null;
      if (!label || (ereignis.key !== 'Enter' && ereignis.key !== ' ')) return;
      var input = label.querySelector('.addon-toggle-input');
      if (!input || input.disabled) return;
      ereignis.preventDefault();
      setzen(input, !input.checked);
    }, true);

    if (reparierteWurzeln) reparierteWurzeln.add(wurzel);
    block.setAttribute('data-mm-schalter-repariert', '1');
  }

  /* Horizon verarbeitet den Kaufknopf per JavaScript und loest dabei auf
     dieser Seite keinen form-submit aus. Darum wird der echte Knopfklick im
     Capture-Schritt angehalten, der Zusatzartikel zuerst angelegt und danach
     derselbe Theme-Klick genau einmal freigegeben. */
  function kaufKlick(ereignis) {
    var ziel = ereignis.target;
    var knopf = ziel && ziel.closest ? ziel.closest('button[type="submit"]') : null;
    var form = knopf && knopf.closest ? knopf.closest('form') : null;
    if (!knopf || !form || form.dataset.mmUpsellhilfe !== 'verbunden') return;

    if (form.dataset.mmUpsellKlickWeiter === '1') {
      delete form.dataset.mmUpsellKlickWeiter;
      return;
    }

    var varianten = ausgewaehlteVarianten();
    if (!varianten.length) return;

    ereignis.preventDefault();
    ereignis.stopImmediatePropagation();
    if (form.dataset.mmUpsellWartet === '1') return;
    form.dataset.mmUpsellWartet = '1';
    knopf.setAttribute('aria-busy', 'true');

    zusatzartikelHinzufuegen(varianten).catch(function (fehler) {
      console.error('[mm-upsellhilfe] Zusatzartikel konnte nicht hinzugefuegt werden:', fehler);
    }).finally(function () {
      fremdeZusatzfelderEntfernen(form);
      delete form.dataset.mmUpsellWartet;
      knopf.removeAttribute('aria-busy');
      form.dataset.mmUpsellWeiter = '1';
      form.dataset.mmUpsellKlickWeiter = '1';
      knopf.click();
      window.setTimeout(function () {
        delete form.dataset.mmUpsellWeiter;
        delete form.dataset.mmUpsellKlickWeiter;
      }, 1500);
    });
  }

  function verbinden() {
    var form = kaufFormular();
    if (!form) return false;
    var knopf = form.querySelector('button[type="submit"]:not([disabled])');
    if (!knopf) return false;
    var bloecke = document.querySelectorAll('section-store--product-addons-block');
    if (!bloecke.length) return false;
    bloecke.forEach(bildKanten);
    bloecke.forEach(schalterReparieren);
    if (form.dataset.mmUpsellhilfe === 'verbunden') return true;

    /* Capture ist absichtlich: Der erste Submit wird angehalten, bis die
       Zusatzartikel erfolgreich im Warenkorb liegen. Der zweite Submit darf
       danach unveraendert durch den Theme-Handler laufen. */
    form.addEventListener('submit', function (ereignis) {
      if (form.dataset.mmUpsellWeiter === '1') {
        delete form.dataset.mmUpsellWeiter;
        fremdeZusatzfelderEntfernen(form);
        return;
      }

      var varianten = ausgewaehlteVarianten();
      if (!varianten.length) {
        fremdeZusatzfelderEntfernen(form);
        return;
      }

      ereignis.preventDefault();
      ereignis.stopImmediatePropagation();
      if (form.dataset.mmUpsellWartet === '1') return;
      form.dataset.mmUpsellWartet = '1';
      knopf.setAttribute('aria-busy', 'true');

      zusatzartikelHinzufuegen(varianten).catch(function (fehler) {
        console.error('[mm-upsellhilfe] Zusatzartikel konnte nicht hinzugefuegt werden:', fehler);
      }).finally(function () {
        fremdeZusatzfelderEntfernen(form);
        delete form.dataset.mmUpsellWartet;
        knopf.removeAttribute('aria-busy');
        form.dataset.mmUpsellWeiter = '1';
        form.requestSubmit(ereignis.submitter || knopf);
      });
    }, true);

    form.dataset.mmUpsellhilfe = 'verbunden';
    bloecke.forEach(function (block) {
      block.dataset.mmUpsellhilfe = 'verbunden';
    });
    return true;
  }

  function starten() {
    var versuche = 0;
    var warten = window.setInterval(function () {
      versuche += 1;
      if (verbinden() || versuche >= 30) window.clearInterval(warten);
    }, 350);
    verbinden();
    document.addEventListener('click', kaufKlick, true);
    window.addEventListener('load', verbinden, { once: true });
    if (document.documentElement) {
      new MutationObserver(verbinden).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
})();
